import React, { useState } from 'react';
import './BulkUpload.scss';
import PropTypes from 'prop-types';
import remove from '../../../../static/images/remove.png';
import file from '../../../../static/images/file.png';
import checkGreen from '../../../../static/images/checkGreen.png';
import TID_Sample from './Terminal_ID_Update_Sample_Sheet.xlsx';
import { toast } from 'react-toastify';

const maxSize = 20 * 1024 * 1024;

const BulkUpload = ({ handleClose, isOpen, actions }) => {
    const [uploadedFile, setUploadedFile] = useState(null);
    const [dragOver, setDragOver] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);

    const handleFileUpload = event => {
        const file = event.target.files[0];

        if (file) {
            if (file.size > maxSize) {
                toast.error('File size exceeds 20 MB. Please upload a smaller file.');
                return;
            }
            setUploadedFile(file);
        }
    };

    // Simulate upload success
    const handleUploadFile = () => {
        const handleSuccess = () => {
            setUploadSuccess(true);
        };

        const handleError = (err) => {
            console.log('Upload failed ERROR', err);
        };
        const formData = new FormData();
        formData.append('inputFile', uploadedFile);

        actions.terminalIDBulkUploadRequest(
            formData,
            handleSuccess,
            handleError
        );
    };

    // Handle drag-and-drop
    const handleDragOver = event => {
        event.preventDefault();
        setDragOver(true);
    };

    const handleDragLeave = () => {
        setDragOver(false);
    };

    const handleDrop = event => {
        event.preventDefault();
        setDragOver(false);

        const file = event.dataTransfer.files[0];
        if (file) {
            if (file.size > maxSize) {
                toast.error('File size exceeds 20 MB. Please upload a smaller file.');
                return;
            }
            setUploadedFile(file);
        }
    };

    // Handle file removal
    const handleFileRemove = () => {
        setUploadedFile(null);
        setUploadSuccess(false);
    };

    if (!isOpen) {
        return <></>;
    }

    return (
        <div className="modal-overlay bulk-modal">
            <div className={'modal-content bulk-modal'}>
                <div className={'modal-header'}>
                    <h2>Terminal Bulk Update</h2>
                    <div>
                        <img
                            src={remove}
                            alt="Close"
                            onClick={() => {
                                handleClose();
                                setUploadSuccess(false);
                                setUploadedFile(null);
                            }}
                        />
                    </div>
                </div>

                {/* Success Screen */}
                {uploadSuccess ? (
                    <div className="upload-success">
                        <div className="success-icon">
                            <img src={checkGreen} alt="Success" />
                        </div>
                        <p>File uploaded successfully</p>
                        <div className="success-buttons">
                            <button
                                className="reset-btn"
                                onClick={handleFileRemove}
                            >
                                Upload Another File
                            </button>
                            <input
                                type="file"
                                id="file-upload"
                                style={{ display: 'none' }}
                                onChange={handleFileUpload}
                                accept=".xlsx"
                            />
                        </div>
                    </div>
                ) : (
                    <div
                        className={`upload-area ${dragOver ? 'drag-over' : ''}`}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                    >
                        <div className="upload-icon">
                            <img src={file} alt="Upload Icon" />
                        </div>

                        {uploadedFile ? (
                            <div className="uploaded-file-info">
                                <p>
                                    {uploadedFile.name}
                                    <span
                                        className="remove-file"
                                        onClick={handleFileRemove}
                                    >
                                        ✕
                                    </span>
                                </p>
                                <div className={'custom-upload-file'}>
                                    <button
                                        className="upload-btn"
                                        onClick={handleUploadFile}
                                    >
                                        Upload File
                                    </button>
                                    {/* <label */}
                                    {/*     htmlFor="file-upload" */}
                                    {/*     className="browse-another-btn" */}
                                    {/* > */}
                                    {/*     Browse File */}
                                    {/* </label> */}
                                </div>
                                <input
                                    type="file"
                                    id="file-upload"
                                    style={{ display: 'none' }}
                                    onChange={handleFileUpload}
                                    accept=".xlsx"
                                />
                            </div>
                        ) : (
                            <>
                                <p>Drop Files Here to Upload</p>
                                <span>
                                    Maximum file size 20MB. Only Excel .XLSX
                                    files are accepted
                                </span>
                                <div className="upload-buttons">
                                    <span>OR</span>
                                    <input
                                        type="file"
                                        id="file-upload"
                                        style={{ display: 'none' }}
                                        onChange={handleFileUpload}
                                        accept=".xlsx"
                                    />
                                    <label
                                        htmlFor="file-upload"
                                        className="browse-btn"
                                    >
                                        Browse File
                                    </label>
                                </div>
                            </>
                        )}
                    </div>
                )}
                <div className="bulk-update-footer">
                    <a
                        href={TID_Sample}
                        className="download-link"
                        download="Terminal_ID_Update_Sample_Sheet.xlsx"
                    >
                        Download sample format
                    </a>
                </div>
            </div>
        </div>
    );
};

BulkUpload.propTypes = {
    handleClose: PropTypes.func,
    isOpen: PropTypes.bool,
    actions: PropTypes.object,
};

export default BulkUpload;
